export const PAYMENT_METHODS = [
  {
    id: 'venmo',
    label: 'Venmo',
    handle: '@MichaelCoffey',
    url: 'https://venmo.com/MichaelCoffey',
  },
  {
    id: 'paypal',
    label: 'PayPal',
    handle: '@coffeymichael',
    url: 'https://paypal.me/coffeymichael',
  },
  {
    id: 'cashapp',
    label: 'Cash App',
    handle: '$CoffeyMichael',
    url: 'https://cash.app/$CoffeyMichael',
  },
];
